import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialRoutingModule } from 'app/modules/social/social-routing.module';
import { SocialService } from 'app/modules/social/services/social.service';
import { SocialPostsComponent } from 'app/modules/social/components/social-posts/social-posts.component';
import { SocialItemListComponent } from './components/social-item-list/social-item-list.component';
import { InstaService } from 'app/modules/social/services/insta.service';
import { InstaAuthComponent } from './components/insta-auth/insta-auth.component';
import { MomentModule } from 'ngx-moment';

@NgModule({
  imports: [CommonModule, SocialRoutingModule, MomentModule],
  declarations: [SocialPostsComponent, SocialItemListComponent, InstaAuthComponent],
  providers: [SocialService, InstaService],
})
export class SocialModule {}
